import LightBulb from "../../assets/icon-lightbulb.svg";

const Icons = {
  LightBulb,
};

export default Icons;
